"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityService = void 0;
const api_1 = require("./api");
const PATH_V1 = '/activity/api/v1';
const PATH_V2 = '/activity/api/v2';
class ActivityService {
    static async getActivities(mobileOnly, featured, isBonus) {
        const requestParams = [];
        requestParams.push(`sort=featured,desc`);
        requestParams.push(`sort=order,asc`);
        requestParams.push(`sort=createdDate,desc`);
        if (mobileOnly) {
            requestParams.push(`visibilityMobile.equals=true`);
        }
        else {
            requestParams.push(`visibilityWeb.equals=true`);
        }
        if (featured !== undefined) {
            requestParams.push(`featured.equals=${featured}`);
        }
        if (isBonus !== undefined) {
            requestParams.push(`isBonus.equals=${isBonus}`);
        }
        const url = `${PATH_V2}/activities?${requestParams.join('&')}`;
        return api_1.API.get({ url });
    }
    static async getUserActivities(mobileOnly, featured, isBonus) {
        const requestParams = [];
        requestParams.push(`webOnly=${!mobileOnly}`);
        requestParams.push(`featured=${Boolean(featured)}`);
        if (isBonus !== undefined) {
            requestParams.push(`isBonus=${Boolean(isBonus)}`);
        }
        const url = `${PATH_V2}/user/activities?${requestParams.join('&')}`;
        return api_1.API.get({ url });
    }
    static async fetchActivity(key) {
        const response = await api_1.API.get({
            url: `${PATH_V1}/activity/${key}`
        });
        return response;
    }
    static async credit(key) {
        return (await api_1.API.post({
            url: `${PATH_V1}/activity/${key}/credit`,
            body: {}
        }));
    }
    static async fetchActivityWithFreqCap(key) {
        return (await api_1.API.get({
            url: `${PATH_V1}/activity/${key}/player`
        }));
    }
    static async getActivity(id) {
        const response = await api_1.API.get({
            url: `${PATH_V1}/activities/${id}`
        });
        return response;
    }
    static async getBonusCampaign(id) {
        const response = await api_1.API.get({
            url: `${PATH_V1}/bonus-campaign/${id}`
        });
        return response;
    }
    static async getActivityWithFreqCap(id) {
        return (await api_1.API.get({
            url: `${PATH_V1}/activities/${id}/player`
        }));
    }
}
exports.ActivityService = ActivityService;
//# sourceMappingURL=activity-service.js.map